import { useEffect, useState } from "react";
import { reject2FAModal, resolve2FAModal } from "src/utils/api-request";

interface ModalDetails {
	title: string;
	description: string;
}

export const useSensitiveOperation = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [isSubmitting, _setIsSubmitting] = useState(false);
	const [modalDetails, setModalDetails] = useState<ModalDetails>({
		title: "Verify Your Identity",
		description: "This action requires two-factor authentication",
	});

	useEffect(() => {
		const handleShow = (event: CustomEvent<ModalDetails>) => {
			setModalDetails(event.detail);
			setIsOpen(true);
		};

		window.addEventListener("show2FAModal", handleShow as EventListener);

		return () => {
			window.removeEventListener("show2FAModal", handleShow as EventListener);
		};
	}, []);

	const handleVerify = async (code: string): Promise<boolean> => {
		resolve2FAModal(code);
		return true;
	};

	const handleCancel = () => {
		reject2FAModal();
		setIsOpen(false);
	};

	return {
		isOpen,
		isSubmitting,
		modalDetails,
		handleVerify,
		handleCancel,
	};
};
